import styled from "styled-components";

export const EarnTitleBlock = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  display: flex;
  gap: 24px;
  .headerL {
    font-weight: 400;
    font-variation-settings: "wght" 700;
  }
  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 16px;
  }
`;

export const EarnInfo = styled.div`
  display: flex;
  gap: 24px;
  overflow: auto;
  white-space: nowrap;
  margin: 0 -24px;
  padding: 0 24px;
  scrollbar-width: none;
  * {
    text-align: left;
  }
  @media (min-width: 1024px) {
    gap: 32px;
    * {
      text-align: right;
    }
  }
`;

export const EarnInfoWrapper = styled.div`
  width: 100%;
  @media (min-width: 1024px) {
    width: auto;
  }
`;
